import { useState } from 'react';
import { useCastContext } from '../cast-context';

export function useCastController() {
  const { player } = useCastContext();
  const [controller] = useState(() => new cast.framework.RemotePlayerController(player!));
  return controller;
}
